import template from './specialty.jade';

export default angular
  .module('cian.addForm.aboutObjectSpecialty', ['cian.addForm.helperSpecialty'])
  .directive('cianAfAboutObjectSpecialty', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: [function () {}],
    controllerAs: 'specialty',
    template,
  })).name;
